<form (ngSubmit)="onSubmit()" [formGroup]="formGroup">
  <div class="row">
    <div class="col-xs-12 col-md-6 form-group">
      <label for="organization" class="zaya-form-sub-header" i18n="label|The name of the practitioner organization.@@lableOrganizationName">Organization Name (Optional)</label>
      <input type="text" id="organization" class="form-control" formControlName="organization">
    </div>
    <div class="col-xs-12 col-md-6">
      <div class="form-group">
        <label for="offersVirtual" class="zaya-form-sub-header" i18n="label|Does the practitioner offer virtual services.@@labelOffersOnlineServices">Do you offer online services?</label>
        <select id="offersVirtual" class="form-control" formControlName="offersVirtual">
          <option [value]="true" i18n="label|Agree.@@labelYes">Yes</option>
          <option [value]="false" i18n="label|Disagree.@@labelNo">No</option>
        </select>
        <span
          class="help-block"
          *ngIf="formGroup.get('offersVirtual').invalid && formGroup.get('offersVirtual').touched"
          i18n="error message|The message shown when an option has not been selected.@@errorOption">
            Please select a valid option.
        </span>
      </div>
    </div>
  </div>
  <div class="form-group">
    <label for="location" class="zaya-form-sub-header" i18n="label|The location of a practitioner.@@labelBusinessAddress">Business Address</label>
    <app-google-places [initialValue]="practitioner.location" (setAddress)="getAddress($event)" addressType="geocode" id="location" controlName="location"></app-google-places>
    <span
      class="help-block"
      *ngIf="formGroup.get('location').invalid && formGroup.get('location').touched"
      i18n="error message|The message shown when an location has not been entered.@@errorAddress">
        Please select a valid location.
    </span>
  </div>
  <div class="row">
    <div class="col-xs-12 col-md-12">
      <div class="form-group">
        <label for="healthCategory" class="zaya-form-sub-header" i18n="label|The practitioner health category.@@labelHealthCategory">Category of practice</label>
        <div class="mb-4 zaya-form-help-text" i18n="label|Help text for the practitioner health category.@@labelApplicationHealthCategoryHelpText">
          Mental well-being includes: psychologists, psychotherapists and other practitioners that address the psychological well-being of an individual.
          Physical well-being includes: physicians, osteopaths, acupuncturists and other practitioners that address the lifestyle behavior choices of
          an individual to ensure health and avoid preventable diseases and conditions.
        </div>
        <select id="healthCategory" class="form-control" formControlName="healthCategory">
          <option *ngFor="let category of healthCategories" [value]="category" i18n="label|Options used for selecting health category.@@labelHealthCategoryOptions">
            { category, select, Mental well-being {Mental well-being} Physical well-being {Physical well-being} Both {Both}}
          </option>
        </select>
        <span
          class="help-block"
          *ngIf="formGroup.get('healthCategory').invalid && formGroup.get('healthCategory').touched"
          i18n="error message|The message shown when an option has not been selected.@@errorOption">
            Please select a valid option.
        </span>
      </div>
    </div>
  </div>

  <hr>

  <div class="d-flex flex-fill justify-content-center">
    <button type="submit" class="btn btn-primary modal-btn mr-2" [disabled]="!formGroup.valid || isLoading">Submit</button>
    <button type="button" class="btn btn-secondary modal-btn" (click)="onDismiss()">Cancel</button>
  </div>

</form>
